import { ReferenceCrud } from "@/components/admin/ReferenceCrud";
import { StatusBadge } from "@/components/admin/AdminUI";

const FIELDS = [
  { name: "name", label: "Warehouse name", required: true, max: 120 },
  { name: "code", label: "Code", required: true, max: 12, hint: "Short unique code, e.g. MIL-01" },
  { name: "country_code", label: "Country (ISO-2)", required: true, max: 2, placeholder: "IT" },
  { name: "city", label: "City", max: 80 },
  { name: "address", label: "Address", type: "textarea", rows: 2, span: 2, max: 400 },
  { name: "is_default", label: "Default warehouse for new stock", type: "switch", span: 2 },
];

const COLUMNS = [
  { key: "name", label: "Warehouse", render: (w) => <span>{w.name}{w.is_default && <StatusBadge status="default" label="Default" tone="ink" className="ml-2" />}</span> },
  { key: "code", label: "Code", render: (w) => <span className="font-mono text-xs">{w.code}</span> },
  { key: "city", label: "Location", render: (w) => [w.city, w.country_code].filter(Boolean).join(", ") },
  { key: "skus", label: "SKUs", className: "text-right tabular", render: (w) => w.stock?.skus ?? 0 },
  { key: "on_hand", label: "On hand", className: "text-right tabular", render: (w) => w.stock?.on_hand ?? 0 },
  { key: "available", label: "Available", className: "text-right tabular font-semibold", render: (w) => w.stock?.available ?? 0 },
];

export default function AdminWarehouses() {
  return <ReferenceCrud resource="warehouses" label="Warehouse" eyebrow="Inventory" description="Physical stock locations. Every balance and movement is recorded per warehouse." fields={FIELDS} columns={COLUMNS} writePerm="inventory.warehouses" searchPlaceholder="Search by name, code or city…" />;
}
